module.exports = __webpack_public_path__ + "img/banner.f00a3466.jpg";